import Instance from '../../../Axios';

// New Actions for the app

const GetParceiro = (id) => async (dispatch) => {
  console.log(id);
  await Instance()
    .get(`/backend/parceiros/${id}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_PARCEIRO', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetParceiro;
